export * from './ProductDetailsTab';
